var _defs, _g, _circle, _circle2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.58 8.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0b5ed6;\n        stroke-miterlimit: 10;\n        stroke-width: .3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ev1FfT.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.57,7.76c.19-.12.46-.3.6-.25.99.2,2.02.62,3.01.8.44.08.64.05,1.02-.16,1.37-.73,2.68-1.75,4.05-2.49.28-.21.23-.7-.12-.8-.3-.09-.64.06-.91.19-.84.41-1.77,1.17-2.61,1.5s-1.89-.19-2.75-.36c-.24-.11-.17-.46.13-.44s.86.26,1.19.33c.21.04.41.12.61,0,.24-.14.23-.5.02-.66-.13-.1-.89-.25-1.12-.32-.78-.24-1.6-.79-2.37-.29l-1.78,1.02,1.05,1.91ZM.98,5.9l-.77.4,1.19,2.25.75-.45-1.17-2.2Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.24,
    cy: 2.49,
    r: 2.34
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 0.86,
    cy: 6.61,
    r: 0.04
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "SCB0hQ.tif"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.47 1.23 7.68 1.23 8.1 1.23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SCB0hQ.tif-2",
    "data-name": "SCB0hQ.tif"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.47 1.92 7.68 1.92 8.1 1.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SCB0hQ.tif-3",
    "data-name": "SCB0hQ.tif"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.47,2.57c-.17.15-.4.23-.63.24l.99,1.23"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.96,1.23h0c.42,0,.77.34.77.77h0c0,.26-.12.48-.32.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/Icon 15.92fc20670c5d26a370536747e4a4fe30.svg";
export { ForwardRef as ReactComponent };